import React from 'react';
import Firebase from 'firebase/app';

import JournalistAllData from './journalistAllData';
import PodcastAllData from './podcastAllData';
import BroadcasterAllData from './broadcasterAllData';
import InfluencerAllData from './influencerAllData';
import Loading from '../misc/Loading';

class ListContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    	item: {},
      listEntries:[],
      list: {},
      isLoading: true,
      plan: this.props.plan,
    };
    this.getDocument = this.getDocument.bind(this);
  }

  componentDidMount() {
    this.getDocument();
	}

  getDocument = () => {
    var db = Firebase.firestore();
    var listData = db.collection('lists')
      .where('createdBy', '==', this.props.subscription.user).where('slug', '==', this.props.params.slug)
      .get()
      .then(documentSnapshots => {
        documentSnapshots.forEach(doc => {
          this.setState({
            list: doc.data(),
            listId: doc.id,
            listEntries: db.collection('lists').doc(doc.id).collection('entries')
          })
        })
      })
      .then( () => this.getFirstItems())
  };

  getFirstItems = () => {
    var listSize = this.state.listEntries
      .get()
      .then(snap => {
        this.setState({
          totalItemCount: snap.size,
        })
      })
    var listEntries = this.state.listEntries
      .where('objectID', '==', this.props.params.objectID)
      .get()
      .then( documentSnapshots => {
      	var item = documentSnapshots.docs[0];
        return this.setItem(item)
      })
  }

  setItem = item => {
    this.setState({
      item: item.data(),
      isLoading: false,
    })
  }

  render() {
    const { item, isLoading, plan } = this.state;

    if (isLoading) {
    	return <Loading />
    } else {
	    return (
	    	<section>
		      <div className="max-w-5xl mx-auto mt-10">
						{ item.dataType === "journalist" ? (
              <JournalistAllData hit={item} plan={plan} /> 
            ) : item.dataType === "podcast" ? (
              <PodcastAllData hit={item} plan={plan} /> 
            ) : item.dataType === "broadcaster" ? (
              <BroadcasterAllData hit={item} plan={plan} /> 
            ) : item.dataType === "influencer" ? (
              <InfluencerAllData hit={item} plan={plan} />
            ) : <div /> }
			    </div>
			  </section>
	    );
		}
  }
}

export default ListContact;
